import React from 'react';
import PropTypes from 'prop-types';

import NumericInput from '../../../components/Inputs/NumericInput';

import {TaskType} from '../../../constants/dataEnum';

import withIntl from '../../../lib/withIntl';

import './InputVolume.scss';

function ToggleButton({children, isActive, onClick}) {
  return (
    <div className={`toggle-button ${isActive && 'active'}`} onClick={onClick} role="presentation">
      {children}
    </div>
  );
}
ToggleButton.propTypes = {
  children: PropTypes.any,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
};
ToggleButton.defaultProps = {
  children: null,
  isActive: false,
  onClick: () => {},
};

const InputVolume = React.forwardRef(
  ({taskType, onTaskTypeChange, value, onChange, min, max, increment, intl}, ref) => (
    <div className="input-volume">
      <span className="input-volume-description">
        {intl.formatMessage({id: 'protocolEditor.setAspirateDispenseVolume.title'})}
      </span>
      <div className="input-volume-content">
        {taskType !== TaskType.AIR_GAP && (
          <div className="input-volume-toggle">
            <ToggleButton isActive={taskType === TaskType.ASPIRATE} onClick={() => onTaskTypeChange(TaskType.ASPIRATE)}>
              <img src="./svg/protocol-editor/aspirate-icon.svg" alt="Aspirate Icon" />
            </ToggleButton>
            {taskType === TaskType.ASPIRATE && (
              <span className="input-volume-toggle-aspirate-text">{intl.formatMessage({id: 'common.aspirate'})}</span>
            )}
          </div>
        )}
        <div className="input-volume-main">
          <NumericInput
            ref={ref}
            value={value}
            onChange={onChange}
            min={taskType === TaskType.AIR_GAP ? 0 : min}
            max={max}
            increment={increment}
          />
          <span className="input-volume-main-description">
            {intl.formatMessage({id: 'protocolEditor.setAspirateDispenseVolume.volume'})}
          </span>
        </div>
        {taskType !== TaskType.AIR_GAP && (
          <div className="input-volume-toggle">
            <ToggleButton isActive={taskType === TaskType.DISPENSE} onClick={() => onTaskTypeChange(TaskType.DISPENSE)}>
              <img src="./svg/protocol-editor/dispense-icon.svg" alt="Dispense Icon" />
            </ToggleButton>
            {taskType === TaskType.DISPENSE && (
              <span className="input-volume-toggle-dispense-text">{intl.formatMessage({id: 'common.dispense'})}</span>
            )}
          </div>
        )}
      </div>
    </div>
  ),
);

InputVolume.propTypes = {
  taskType: PropTypes.string,
  onTaskTypeChange: PropTypes.func,
  value: PropTypes.number,
  onChange: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
  increment: PropTypes.number,
  intl: PropTypes.any.isRequired,
};

InputVolume.defaultProps = {
  taskType: '',
  onTaskTypeChange: () => {},
  value: 0,
  onChange: () => {},
  min: -13,
  max: 13,
  increment: 0.1,
};

export default withIntl(InputVolume);
